import LongformMenu from './longformMenu';

const LongformMenuConfig = {
  name: 'longformMenu',
  class: LongformMenu,
  querySelector: {
    article: '.page-type-longform article.type-longform',
    headerInnerWrap: '.single-longform__header--container',
    menuToggleButton: '.menu-toggle',
    menuToggleTarget: '.single-longform__child-menu',
    menuToggleWrapper: '.single-longform__child-menu-group',
    menuToggleWrapperClosed: '.single-longform__child-menu-group:not([aria-hidden="true"])', // eslint-disable-line max-len

  },
  querySelectorAll: {
    menuItems: '.has-grandchild-menu',
    childMenuItems: '.has-grandchild-menu',
  },
};

export default LongformMenuConfig;
